import { render, staticRenderFns } from "./scoreThesis.vue?vue&type=template&id=b24bcf06&scoped=true&"
import script from "./scoreThesis.vue?vue&type=script&lang=js&"
export * from "./scoreThesis.vue?vue&type=script&lang=js&"
import style0 from "./scoreThesis.vue?vue&type=style&index=0&id=b24bcf06&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b24bcf06",
  null
  
)

export default component.exports